export default {
  title: {
    management: '面试/评估问卷管理',
    questionnaire: {
      add: '新增问卷',
      edit: '编辑问卷',
      view: '查看问卷'
    }
  },
  menu: '面试/评估管理',
  tab: {
    questionnaire: '问卷',
    question: '问题',
    scoreScale: '分制设置'
  },
  label: {
    questionnaireName: '问卷名称',
    questionnaireChineseName: '问卷中文名称',
    questionnaireEnglishName: '问卷英文名称',
    company: '公司',
    scale: '分制',
    hmRatingsPrivate: '隐私评分',
    hideRatingsFromHm: '隐私评分',
    status: '状态',
    timesUsed: '使用次数',
    lastUpdate: '最后更新',
    question: '问题',
    type: '类型',
    required: '必填',
    scoreWeight: '评分权重 (%)',
    questionType: '问题类型',
    chineseTitle: '中文标题',
    englishTitle: '英文标题',
    chineseOptions: '中文选项',
    englishOptions: '英文选项',
    locked: '锁定'
  },
  btn: {
    view: '查看',
    copy: '复制',
    addQuestion: '添加问题',
    addNewQuestion: '添加',
    copyQuestionnaire: '复制为新问卷',
    all: '全部',
    rating: '评分题',
    text: '文本题',
    single: '单选题',
    multiple: '多选题',
    date: '日期题'
  },
  placeholder: {
    company: '所有公司',
    status: '所有状态',
    type: '类型',
    questionType: '请选择问题类型',
    options: '请输入选项，或从 Excel 粘贴。',
    searchQuestion: '搜索问题'
  },
  questionType: {
    rating: '评分题',
    text: '文本题',
    single: '单选题',
    multiple: '多选题',
    date: '日期题'
  },
  status: {
    enabled: '启用',
    disabled: '停用'
  },
  questionnaireStatus: {
    open: '启用',
    closed: '停用'
  },
  hmRatings: {
    private: '保密',
    public: '公开'
  },
  dialog: {
    addQuestion: '新增问题',
    editQuestion: '编辑问题',
    viewQuestion: '查看问题'
  },
  message: {
    selectedQuestion: '已选择 {count} 个问题',
    lockedQuestionnaire: '该问卷已上线。你只能编辑分数权重，隐私设置和必填设置。',
    questionRequired: '请至少添加一个问题后再保存。',
    weightTotalInvalid: '分数权重需要等于100%',
    scaleRequiredForRating: '请选择分制',
    saveBeforeCopy: '请先保存问卷后再复制。',
    hasDuplicateQuestionnaire: '该问卷名称已存在，请重新输入'
  }
}
